// ./context/auditLog/auditLogInitialState.js

export default {
    studentLogs: [],
    entityLogs: [],
    userActivity: [],
    logsByAction: [],
    securityEvents: [],
    failedLogins: [],
    criticalEvents: [],
    complianceReport: null,
    systemActivity: null,
    statistics: null,
    searchResults: [],
    isLoading: false,
    error: null
}